import { Box } from '@mui/material';
import { GridFilterInputValueProps, GridFilterItem, useGridRootProps } from '@mui/x-data-grid-pro';
import { useEffect, useRef, useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const timeOffset = new Date().getTimezoneOffset() * 60000;

export const applyFilter = (filterItem: GridFilterItem) => {
  if (!filterItem.value) {
    return null;
  }

  const date = new Date(filterItem.value);
  const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getTime() + timeOffset;
  const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999).getTime() + timeOffset;

  return (value: number): boolean => {
    return value != null && startOfMonth <= value && value <= endOfMonth;
  };
};

export const MonthPickerInput = (props: GridFilterInputValueProps) => {
  const rootProps = useGridRootProps();
  const { item, applyValue } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filterTimeout = useRef<any>(undefined);
  const [filterValueState, setFilterValueState] = useState<string | null>(item.value ?? '');

  useEffect(() => {
    return () => {
      clearTimeout(filterTimeout.current);
    };
  }, []);

  useEffect(() => {
    const itemValue = item.value ?? null;
    setFilterValueState(itemValue);
  }, [item.value]);

  const updateFilterValue = (date: string | null) => {
    clearTimeout(filterTimeout.current);
    setFilterValueState(date);

    filterTimeout.current = setTimeout(() => {
      applyValue({ ...item, value: date });
    }, rootProps.filterDebounceMs);
  };

  const handleLowerFilterChange = (date: string) => {
    let newDate = new Date(date);
    newDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
    newDate = new Date(newDate.getTime() - timeOffset);

    updateFilterValue(newDate.toISOString());
  };

  let currentFilterValue = new Date(filterValueState || '');
  currentFilterValue = new Date(currentFilterValue.getTime() + timeOffset);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'end',
        height: '2.3rem',
        width: '24rem'
      }}>
      <DatePicker
        value={currentFilterValue}
        onChange={(newValue) => handleLowerFilterChange(String(newValue))}
        slotProps={{ textField: { size: 'small', error: false } }}
        views={['month', 'year']}
        sx={{ mr: 2, mt: 2 }}
        format="MMM yyyy"
      />
    </Box>
  );
};
